var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLystoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.56 0C111.891 0 100 11.8913 100 26.56V99.9994H26.56C11.8913 99.9994 0 111.891 0 126.559V273.439C0 288.108 11.8913 299.999 26.56 299.999H173.44C188.109 299.999 200 288.108 200 273.439V200H273.44C288.109 200 300 188.109 300 173.44V26.56C300 11.8913 288.109 0 273.44 0H126.56ZM200 200V126.559C200 111.891 188.109 99.9994 173.44 99.9994H100V173.44C100 188.109 111.891 200 126.56 200H200Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLystoWhite);
export default __webpack_public_path__ + "static/media/lysto_white.1d572f311e53f28f66948013b48accf7.svg";
export { ForwardRef as ReactComponent };